import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'
import { useState } from 'react'
import { useTheme } from '@emotion/react'
import { TextFieldWithDarkMode } from 'dark-mode-components'
import { isFieldEmpty } from 'utils'
import { Reference } from 'api/model'

const ReferenceDialog = ({
  onCloseDialog,
  referenceIndex,
  submitCount,
  onAddReference,
  onDeleteReference,
  onUpdateReference,
  references,
}: {
  onCloseDialog: () => void
  referenceIndex: number
  submitCount: number
  onAddReference: (title: string, url: string) => void
  onDeleteReference: (index: number) => void
  onUpdateReference: (index: number, title: string, url: string) => void
  references: Reference[]
}) => {
  const theme = useTheme()

  const reference = references[referenceIndex]

  const [title, setTitle] = useState(reference?.title ?? '')
  const onTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value)
  }

  const [url, setUrl] = useState(reference?.url ?? '')
  const onUrlChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUrl(event.target.value)
  }

  const onDeleteClicked = () => {
    if (reference) {
      onDeleteReference(referenceIndex)
    }
  }

  const onSubmitClick = () => {
    if (reference) {
      onUpdateReference(referenceIndex, title, url)
      onCloseDialog()
    } else {
      onAddReference(title, url)
      onCloseDialog()
    }
  }

  return (
    <Dialog open={true}>
      <DialogTitle>{reference ? 'Edit reference' : 'Add reference'}</DialogTitle>
      <DialogContent>
        <Stack mt={4} spacing={4}>
          <TextFieldWithDarkMode
            className="has-label"
            isDarkBackdrop={true}
            theme={theme}
            required
            label="Title"
            placeholder="Enter a descriptive title for your reference"
            value={title}
            onChange={onTitleChange}
            error={submitCount > 0 && isFieldEmpty(title)}
            helperText={submitCount > 0 && isFieldEmpty(title) && 'You must enter a title'}
          />

          <TextFieldWithDarkMode
            className="has-label"
            isDarkBackdrop={true}
            theme={theme}
            required
            label="URL"
            placeholder="Enter a URL for your reference"
            value={url}
            onChange={onUrlChange}
            error={submitCount > 0 && isFieldEmpty(url)}
            helperText={submitCount > 0 && isFieldEmpty(url) && 'You must enter a URL'}
          />
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: reference ? 'space-between' : 'flex-end',
        }}>
        {reference && <Button onClick={onDeleteClicked}>Delete</Button>}

        <Stack alignItems="center" direction="row" spacing={1}>
          <Button onClick={onCloseDialog}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={onSubmitClick}>
            {reference ? 'Save' : 'Add'}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}

export default ReferenceDialog
